import { render, staticRenderFns } from "./evaluation-details.vue?vue&type=template&id=b43ba5de&scoped=true"
import script from "./evaluation-details.vue?vue&type=script&lang=js"
export * from "./evaluation-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43ba5de",
  null
  
)

export default component.exports